/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Rollout service type VCDR/VMCFS for tenants, SYSTEM for internal rollouts.
 */
export type RolloutServiceType = 'VCDR' | 'VMCFS' | 'SYSTEM';

export const RolloutServiceType = {

    VCDR: 'VCDR' as RolloutServiceType,

    VMCFS: 'VMCFS' as RolloutServiceType,

    SYSTEM: 'SYSTEM' as RolloutServiceType
};

